import React, { useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { api } from './api'
import { Arrow, Logo, Spinner } from './components'
import { PricingCards } from './LandingPage'

export default function PricingPage({ session }) {
  const [params] = useSearchParams()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const selectedPlan = params.get('plan')
  const selectedBilling = params.get('billing') || 'yearly'

  React.useEffect(() => {
    if (!session || !selectedPlan) return
    setLoading(true)
    api('/api/billing/checkout', { method: 'POST', body: JSON.stringify({ planCode: selectedPlan, billingPeriod: selectedBilling }) })
      .then(data => { window.location.href = data.url })
      .catch(err => { setError(err.message); setLoading(false) })
  }, [session, selectedPlan, selectedBilling])

  if (!session) return <div className="simple-page"><Logo/><div className="simple-card"><h1>Log in to choose your plan.</h1><p>Payment happens before we ask for a channel or video folder.</p><Link className="button button-primary" to={`/login?next=${encodeURIComponent(window.location.pathname + window.location.search)}`}>Log in <Arrow/></Link></div></div>
  if (loading) return <div className="simple-page"><Logo/><div className="simple-card"><Spinner/><h1>Opening secure checkout…</h1><p>No channel information has been collected.</p></div></div>
  return <div className="pricing-page"><header><Logo/><Link to="/app">My vault</Link></header><main><div className="section-heading centered"><span className="eyebrow">HARD PAYWALL. CLEAR PROMISE.</span><h1>Choose how many videos<br/><em>you never want to lose.</em></h1></div>{error && <div className="form-error max-error">{error}</div>}<PricingCards authenticated/></main></div>
}
